export const TOGGLE_EMPLOYED_BY_NAME = 'TOGGLE_EMPLOYED_BY_NAME_VEIDS'

export const toggleItemByName = data => {
  return {
    type: TOGGLE_EMPLOYED_BY_NAME,
    data: data
  }
}

export const SET_POPUP = 'SET_POPUP_VEIDS';

export const setActive = props => {
  return {
    type: SET_POPUP,
    data: props
  }
}

export const TOGGLE_ALL = 'DISABLE_ALL_EMPLOYED_VEIDS';

export const toggleAll = props => {
  return {
    type: TOGGLE_ALL,
    data: props
  }
}

export const TOGGLE_ALL_TYPE = 'TOGGLE_ALL_EMP_CONT_TYPE_VEIDS';

export const toggleAllType = props => {
  return {
    type: TOGGLE_ALL_TYPE,
    data: props
  }
}

export const DISABLE_ALL = 'DISABLE_ALL_EMPL_VEIDS';

export const disableAll = props => {
  return {
    type: DISABLE_ALL,
    data: props
  }
}


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/employedCountVeids/actions.js